import { render } from "./totp_form.vue?vue&type=template&id=6fb04413"
import script from "./totp_form.js?vue&type=script&lang=js"
export * from "./totp_form.js?vue&type=script&lang=js"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__